export const studentInBusStatus = {
    notInBus: 0,
    oldBus: 1,
    newBus: 2
}

export const tripType = {
    roundTrip: 0,
    oneWay: 1,
    returnOnly: 2
}

// BusTripType from the new driverAssistant API contract (trips/start body) - distinct numbering from tripType above
export const busTripType = {
    oneWay: 0,
    return: 1,
    roundTrip: 2
}

// StudentBusStatusType from the new driverAssistant API contract (per-trip roster status)
// absent (4) is a project-local additive extension riding the same int column, not a locked package enum member
export const studentBusStatusType = {
    atSchool: 0,
    onBus: 1,
    gettingHome: 2,
    home: 3,
    absent: 4
}
